import React from 'react';
import { isMobile } from 'react-device-detect';
import Config from '../../../../../Config';

const Support = () => {
    const phoneLabel = isMobile ? 'למוקד הטלפוני' : window.Config.technicalSupportPhone;

    return (
        <div className='support-wrapper'>
            <div className='support-text'>
                משהו לא עובד? <br /> אנחנו כאן כדי לעזור!
            </div>
            <div className='support-links'>
                {isMobile ? (
                    <a href={`tel:${Config.technicalSupportPhone}`} className='call-center-link'>
                        <span>{phoneLabel}</span>
                    </a>
                ) : (
                    <span className='call-center-link call-center-link--text'>{phoneLabel}</span>
                )}
            </div>
        </div>
    );
};

export default Support;
